module.exports = __webpack_public_path__ + "static/media/Bulldog924_4c.a1b5e3a9.svg";